import type { ChatType as AdminChatFilterType } from "@circle-react/types/CommunityBot/ChatSort";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";

import { CHAT_TYPES } from "@/react/components/SettingsApp/CommunityInbox/Sidebar/constants";

export const markAdminChatAsRead = (chat: Chat): Chat =>
  chat.has_unread_messages_for_admin
    ? { ...chat, has_unread_messages_for_admin: false }
    : chat;

export const nextAdminChatsAfterMarkAllAsRead = (
  adminChats: Chat[],
  activeChatType?: AdminChatFilterType,
): Chat[] =>
  activeChatType === CHAT_TYPES.UNREAD
    ? []
    : adminChats.map(markAdminChatAsRead);
